import React from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";

// Edit an existing assignment -- backs the "Edit Assignment"/"Extend Due
// Date" actions in AssignmentActionsMenu.jsx. Mirrors AssignFormModal.jsx's
// field density/grid and saving-state button pattern for consistency, but
// only exposes the fields the backend documents as editable after creation
// (see the openEdit/handleUpdateAssignment comments in useFormAssignments.js
// -- form_version_id/user_ids are NOT editable here, department_id/
// related_task_id are passed through untouched by the hook and have no
// user-facing control in this modal).
export default function EditAssignmentModal({ target, form, saving, onChange, onClose, onSave, users }) {
  if (!form) return null;

  const titleEmpty = !form.assignment_title || !form.assignment_title.trim();

  return (
    <Modal show={!!target} onHide={onClose} centered size="lg" className="unit-modal">
      <Modal.Header closeButton>
        <Modal.Title>Edit Assignment — {target?.assignment_title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="g-2">
          <Col md={6}>
            <Form.Label>Assignment Title</Form.Label>
            <Form.Control
              value={form.assignment_title}
              onChange={(e) => onChange("assignment_title", e.target.value)}
            />
          </Col>
          <Col md={6}>
            <Form.Label>Due Date</Form.Label>
            <Form.Control type="datetime-local" value={form.due_at} onChange={(e) => onChange("due_at", e.target.value)} />
          </Col>

          <Col md={12}>
            <Form.Label>Instructions (optional)</Form.Label>
            <Form.Control as="textarea" rows={2} value={form.instructions} onChange={(e) => onChange("instructions", e.target.value)} />
          </Col>

          <Col md={3}>
            <Form.Check type="checkbox" label="Mandatory" checked={form.is_mandatory} onChange={(e) => onChange("is_mandatory", e.target.checked)} />
          </Col>
          <Col md={3}>
            <Form.Check type="checkbox" label="Allow multiple submissions" checked={form.allow_multiple_submissions} onChange={(e) => onChange("allow_multiple_submissions", e.target.checked)} />
          </Col>
          <Col md={3}>
            <Form.Label className="small mb-0">Max submissions</Form.Label>
            <Form.Control type="number" min="1" value={form.maximum_submissions} disabled={!form.allow_multiple_submissions} onChange={(e) => onChange("maximum_submissions", e.target.value)} />
          </Col>
          <Col md={3}>
            <Form.Check type="checkbox" label="Allow late submission" checked={form.allow_late_submission} onChange={(e) => onChange("allow_late_submission", e.target.checked)} />
          </Col>

          <Col md={3}>
            <Form.Check type="checkbox" label="Allow save draft" checked={form.allow_save_draft} onChange={(e) => onChange("allow_save_draft", e.target.checked)} />
          </Col>
          <Col md={4}>
            <Form.Label className="small mb-0">Reviewer (for future use)</Form.Label>
            <Form.Select value={form.reviewer_id} onChange={(e) => onChange("reviewer_id", e.target.value)}>
              <option value="">None</option>
              {users.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
            </Form.Select>
          </Col>
          <Col md={5}>
            <Form.Label className="small mb-0">Approver (for future use)</Form.Label>
            <Form.Select value={form.approver_id} onChange={(e) => onChange("approver_id", e.target.value)}>
              <option value="">None</option>
              {users.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
            </Form.Select>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="unit-modal-footer">
        <Button className="unit-btn unit-btn-light" onClick={onClose} disabled={saving}>Cancel</Button>
        <Button className="unit-btn unit-btn-primary" onClick={onSave} disabled={saving || titleEmpty}>
          {saving && <Spinner animation="border" size="sm" className="me-2" />}
          {saving ? "Saving..." : "Save Changes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
